import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import { sendPasswordReset } from '../../actions/auth'
import ForgotPasswordModal from '../../components/login/forgot-password'

const mapStateToProps = (state) => ({
  initialValues: {
    email: state.form.login.email.value || '',
    redirect: 'frontend'
  }
})

const mapDispatchToProps = (dispatch, newProps) => ({
  onSubmit (data) {
    return dispatch(sendPasswordReset(data)).then(
      (action) => dispatch(replace('/login/forgot-password-success'))
    )
  },

  handleClose () {
    dispatch(replace('/login'))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordModal)



// WEBPACK FOOTER //
// ./src/containers/login/forgot-password-container.js